document.addEventListener('DOMContentLoaded', function() {


    document.addEventListener('click', function(event) {
        if (event.target.matches('.change-color-prodcut-coll')) {
          const clickedElement = event.target;
          const mainProductHandle = clickedElement.getAttribute('data-main-product-handle');
          var main_product = document.querySelector(`product-card[handle="${mainProductHandle}"]`);
          var main_product_id =  clickedElement.getAttribute('data-main-product-id');
          var color_product_id = clickedElement.getAttribute('data-prodcut-color-id');      
          var pProductFamilyAllClasses = document.querySelectorAll(`.${main_product_id}`);
          pProductFamilyAllClasses.forEach(function(element) {
                if(element.classList.contains(`${color_product_id}`)){
                  if(element.classList.contains(`show-display-contents`)){
                    element.style.display = 'contents';
                  }else{
                    element.style.display = 'block';
                  }
                }else{
                  element.style.display = 'none';
                }
            });
            const productCardHandle = document.querySelector(`product-card[handle="${mainProductHandle}"]`);
            const productUrl = clickedElement.getAttribute('data-prodcut-url');
            const productTitle = clickedElement.getAttribute('data-product-title');
            const productPrice = clickedElement.getAttribute('data-product-price');
            const productCompareAtPrice = clickedElement.getAttribute('data-product-compare-at-price');
          
            const productInfo = productCardHandle.querySelector('.product-card__info');
            const productTitleElement = productInfo.querySelector('.product-title');
            const productPriceElement = productInfo.querySelector('.price-list');
          
            // const productPrice = productCardHandle.querySelector('div[class="v-stack justify-items-center gap-1"]');
            productTitleElement.href = productUrl;
            productTitleElement.innerHTML = productTitle;

            document.querySelectorAll(`button[data-main-product-handle="${mainProductHandle}"]`).forEach(otf => {
                otf.classList.remove("is-selected");
            });
            clickedElement.classList.add("is-selected");
        }
    });
});
